<template>
  <div class="calendar">
    <date-picker
        ref="datepicker"
        :model-value="date"
        @update:modelValue="$emit('update:date', $event)"
        :locale="locale"
        :attributes="attributes"
    />
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";

export default {
  name: "Calendar",
  components: {
    DatePicker,
  },
  props: {
    date: {
      type: Date,
      default: () => new Date(),
    },
    selectedDates: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:date"],
  data() {
    return {
      locale: "ru",
      attributes: [ ],
    };
  },
  watch: {
    selectedDates: {
      immediate: true,
      handler(newDates) {
        this.attributes = [
          {
            highlight: {
              key: "selectedDays",
              fillMode: "outline",
              color: "green",
            },
            dates: newDates,
          },
        ];
      }
    },
  },
};
</script>
